function getEmailLocalPart(email) {
  return email.split('@')[0] || email;
}
export function resolveCommitAuthorFromSupabaseUser(user, emailFallback) {
  const email = user.user_email || user.email || emailFallback;
  if (!email) {
    return undefined;
  }
  const displayName = user.user_name || user.user_metadata?.display_name;
  const fullName = user.user_metadata?.full_name || user.user_metadata?.name;
  const name = displayName || fullName || getEmailLocalPart(email);
  return {
    name,
    email
  };
}